import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-start justify-between gap-0.5" }
const _hoisted_2 = { class: "text-xs sm:text-lg font-bold leading-none text-brown" }
const _hoisted_3 = { class: "hidden sm:inline" }
const _hoisted_4 = { class: "mt-1 sm:mt-2 flex flex-col sm:flex-row sm:items-center sm:justify-between bg-white/80 px-1 sm:px-2 py-0.5 sm:py-1 rounded border border-divider/70 text-center sm:text-left" }
const _hoisted_5 = { class: "font-caudex font-bold text-[11px] sm:text-sm text-brown leading-tight" }
const _hoisted_6 = { class: "hidden lg:block mt-1.5" }
const _hoisted_7 = { class: "hidden sm:block mt-2 pt-1.5 border-t border-divider/60" }
const _hoisted_8 = { class: "flex items-center justify-between text-[10px] text-muted mt-0.5" }
const _hoisted_9 = { class: "text-active font-semibold" }

import { computed } from "vue";
import { MonthDayReport } from "@/types/calculators";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'DayCardComponent',
  props: {
    dayReport: {},
    cardNumber: {},
    isCardSelected: { type: Boolean },
    isCardMuted: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();

const cardsValues = computed(() => {
  let values = {
    card: "",
    cardBadge: {
      classes: "",
      content: "",
    },
  };

  switch (props.dayReport.tier) {
    case "golden":
      values["card"] = "bg-[#FFFDF7] border-gold/60";
      values["cardBadge"] = {
        classes: "bg-gold text-white",
        content: `★ ${props.dayReport.combined_index}%`,
      };
      break;
    case "favorable":
      values["card"] = "bg-[#F7FCF8] border-success/40";
      values["cardBadge"] = {
        classes: "bg-success text-white",
        content: `✓ ${props.dayReport.combined_index}%`,
      };
      break;
    case "personal_routine":
      values["card"] = "bg-white border-divider";
      values["cardBadge"] = {
        classes: "bg-beige text-active border border-active/2",
        content: `Рутина`,
      };
      break;
    case "personal_clash":
      values["card"] = "bg-[#FDF6F6] border-error/40";
      values["cardBadge"] = {
        classes: "bg-error text-white",
        content: `冲 Пробій`,
      };
  }

  return values;
});

const structure = computed<{ content: string; classes: string }>(() => {
  if (props.dayReport.tier == "personal_clash") {
    return {
      content: `✕ ${props.dayReport.personal_status.warnings[0]}` ?? "",
      classes: "text-error",
    };
  }
  if (props.dayReport.personal_status.structures.length > 0) {
    return {
      content: props.dayReport.personal_status.structures[0] ?? "",
      classes: "text-[#9A6E1E]",
    };
  }
  if (props.dayReport.personal_status.stars.length > 0) {
    return {
      content: props.dayReport.personal_status.stars[0] ?? "",
      classes: "text-[#9A6E1E]",
    };
  }
  return {
    content: `${props.dayReport.personal_status.ten_god_stem} / ${props.dayReport.personal_status.ten_god_branch}`,
    classes: "text-muted",
  };
});

const doing = computed<{ content: string; isBad: boolean }>(() => {
  if (props.dayReport.yi_preview.length > 0) {
    return {
      content: `宜: ${props.dayReport.yi_preview[0].name} (${props.dayReport.yi_preview[0].ua})`,
      isBad: false,
    };
  }
  if (props.dayReport.ji_preview.length > 0) {
    return {
      content: `忌: ${props.dayReport.ji_preview[0].name}`,
      isBad: true,
    };
  }
  return {
    content: "",
    isBad: true,
  };
});

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["p-1.5 sm:p-3 rounded-lg sm:rounded-xl border transition-all cursor-pointer flex flex-col justify-between min-h-[68px] sm:min-h-[155px] relative hover:shadow-md", [
      cardsValues.value.card,
      __props.isCardSelected ? 'ring-2 ring-active ring-offset-1' : '',
      __props.isCardMuted ? 'opacity-25 grayscale pointer-events-none' : '',
    ]])
  }, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(__props.cardNumber), 1),
        _createElementVNode("span", {
          class: _normalizeClass(["px-1 py-0.5 rounded text-[8px] sm:text-[10px] font-bold leading-none", cardsValues.value.cardBadge.classes])
        }, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(cardsValues.value.cardBadge.content), 1)
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(__props.dayReport.pillars.day), 1),
        _createElementVNode("span", {
          class: _normalizeClass(["text-[9px] sm:text-[11px] font-bold leading-tight", 
            __props.dayReport.officer_12.is_auspicious
              ? 'text-success'
              : 'text-alternative-gray'
          ])
        }, _toDisplayString(__props.dayReport.officer_12.name), 3)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: _normalizeClass(["text-[10px] font-semibold truncate", structure.value.classes])
        }, _toDisplayString(structure.value.content), 3)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        class: _normalizeClass(["text-[10px] font-medium truncate", doing.value.isBad ? 'text-error' : 'text-success'])
      }, _toDisplayString(doing.value.content), 3),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_i18n_t, {
          keypath: "calculators.personal-date.day-rang",
          tag: "span"
        }, {
          rang: _withCtx(() => [
            _createElementVNode("strong", null, _toDisplayString(__props.dayReport.general_status.rank_code), 1)
          ]),
          _: 1
        }),
        _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)("calculators.personal-date.details")), 1)
      ])
    ])
  ], 2))
}
}

})